<template>
  <div class="body">
        <app-header></app-header>
        <div class="app flex-row align-items-center" style="position:relative; top:0px; margin:0px;padding:0px">
          <!-- <div  style="width:100%"> -->
            <!-- <b-row class="justify-content-center"> -->
              <!-- <b-col md="8" sm="8"> -->
          <div  
          v-loading="verifying"  
          element-loading-text="Vérification de l'Email"
          element-loading-spinner="el-icon-loading"
          style="width:33%;height:250px" class="container" align="center">
          <el-card  class="box-card" align="center" style="position:relative;top:20%">
              <!-- <fa v-if="verified" icon="check" style="color:green" size="8x" /> 
              <fa v-if="!verified && !verifying" icon="check" style="color:red" size="8x" /> <br> -->
          <span v-if="verified">
          <el-alert 
          title=""
          style="width:100%; font-weight:20px"
          type="success"
          show-icon
          > 
            <span style="font-size:19px">
              Email vérifié avec succès, Vous pouvez maitenant vous connecter à votre espace fournisseur.
            </span>
          </el-alert>
          <br>
          <el-button  type="primary" @click="$router.push('/pages/login')">Connectez Vous</el-button>
          </span>

          <span v-if="!verified && !verifying">
          <el-alert 
          title=""
          style="width:100%; font-weight:20px"
          type="error"
          show-icon
          >
          <span style="font-size:19px">
              {{errorMessage}}
            </span>
          </el-alert>
          <br>
          <el-button  type="primary" @click="$router.push('/pages/home')">Revenir à la page d'accueil</el-button>
          </span>
          </el-card>
        </div>
              <!-- </b-col> -->
            <!-- </b-row> -->
          <!-- </div> -->
        </div>
           
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AppHeader from '../../containers/AppHeader'
import axios from 'axios'
import { setInterval } from 'timers';

export default {
  name: 'messages',
   components:{
    AppHeader,
  },
  data: function () {
    return {
      show: true,
      token:'',
      verifying:true,
      verified:false,
      errorMessage:"",
      attemps:0
    }
  },
  methods:{
     ...mapActions([
      
    ])
  },
  computed:{
   ...mapState([
     
   ])
  },
  mounted(){
    // this.getMessages()
    this.token = this.$route.params.token
    console.log('routeParams',this.token)

     axios.get(this.$store.state.baseurl+'/email/verify/'+this.token, {
        headers:{
            'Content-Type':'application/json'
        }
     }).then(resp=>{
        this.verifying = false
        if(resp.data.data == 'verified_ok') this.verified = true
        else {
          this.verified = false
          this.errorMessage = "Lien invalide ou Email déjà vérifié"
        }
    }).catch(err=>{
      // document.location.reload()
      console.log('error',err)
      this.errorMessage = "une erreur s'est produite, veuillez reéssayer plutard."
      this.verifying = false
      this.verified = false
    })

  }
}
</script>


<style scoped>
  .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

   .menu-item{
    padding-right:20px 
  }

  .body{
    background-color: white
  }

  .box-card{
    border: 10px 10px
    
  }
</style>
